/**
 * Sentry configuration
 * This file contains configuration for Sentry error tracking
 */

/**
 * List of errors to ignore in Sentry reporting
 * Add patterns for errors that should not be reported to Sentry
 */
const SENTRY_IGNORE_ERRORS = [
  // Internal library errors
  "_abt/*init*/(arg[0]='isArray')",
  // Client script errors (not from our app)
  "TypeError: Cannot read properties of null (reading 'contentWindow')",
  // Is logged to AWS ALB
  "Opened not found page with status 404.",
  // Happens on runners
  "Error - unable to load fileServer storage data. Maybe you have incorrect url?",
  // GTM script zaletsi (not from our app)
  "No error message",
  // GTM script zaletsi (not from our app)
  "Non-Error exception captured with keys: currentTarget, isTrusted, target, type",
];

module.exports = SENTRY_IGNORE_ERRORS;
